export default  {
    "Invitation Sent": "Interview Scheduled",
    "Waiting for evaluation": "Processing - Transcriptions",
    "BM Rejected": "HH Rejected",
    "BM Under Verification": "Processing - Quality checks",
    "BM Verified":"Review Required"
  };